import VideoDataStore from "models/video_data_store"

export class CustomPlayButtonControl {
  static style = null

  constructor(video) {
    this.video = video
    this.unbinds = []
    this.videoDataStore = VideoDataStore.getStore(this.video.hashedId())
  }

  mount(mountRoot) {
    const control = document.createElement("div")
    control.dataset.testid = "custom-play-button"
    control.classList.add("c-play-button")
    control.classList.add("invisible") // Do not display the button twice after lazy loading
    control.classList.add(`-${this.video.params.playButtonStyle || "light"}`)
    control.innerHTML = this.playButton()
    mountRoot.appendChild(control)
    control.addEventListener("click", () => { this.video.play(); control.classList.add("invisible") })
    this.video.bind("pause", () => { this.pauseCallback(control) })
    this.video.bind("play", () => { control.classList.add("invisible") })
  }

  playButton() {
    if (this.courseResumable()) {
      return "<button \
        class='btn btn-icon btn-icon btn-sales btn-lg'> \
        <span><ion-icon name='play'></ion-icon><span class='btn-text'>Resume course</span></span></button>"
    }

    return '<svg width="100%" height="100%" viewBox="0 0 164 165" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="82" cy="82.9365" r="62" fill="#DA3D1D"/><path d="M70.4689 100.187C69.8933 100.186 69.3279 100.035 68.8283 99.7489C67.7033 99.1114 67.0039 97.8739 67.0039 96.5304V69.3429C67.0039 67.9958 67.7033 66.762 68.8283 66.1245C69.3398 65.8305 69.9209 65.6794 70.5108 65.6868C71.1007 65.6942 71.6778 65.8599 72.1817 66.1667L95.4177 80.0754C95.9019 80.3791 96.3011 80.8007 96.5778 81.3009C96.8546 81.801 96.9997 82.3632 96.9997 82.9348C96.9997 83.5064 96.8546 84.0686 96.5778 84.5687C96.3011 85.0689 95.9019 85.4905 95.4177 85.7942L72.178 99.7067C71.6622 100.018 71.0715 100.184 70.4689 100.187Z" fill="white"/></svg>'
  }

  pauseCallback(control) {
    control.classList.remove("invisible")

    if (this.courseResumable()) {
      control.classList.remove("c-play-button")
      control.classList.add("resume-course-button")
      control.innerHTML = this.playButton()
    } else {
      control.classList.remove("c-play-button")
      control.innerHTML = ""
    }
  }

  courseResumable() {
    return this.videoDataStore.getMaxWatchedSecond() > 0 && this.video.options.resumeCourseButton === true
  }
}

CustomPlayButtonControl.handle = 'customPlayButton'
CustomPlayButtonControl.type = 'above-control-bar'
